import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import { Alert, Button, Col, Row } from "react-bootstrap";
import OrderRecapViewModel from "../../../viewModels/multiEshop/orderRecapViewModel";

const RecommendationAlert: FunctionComponent<{
  vm: OrderRecapViewModel;
  descriptionLocalizationCode?: string;
  removeButtonLabelLocalizationCode?: string;
  closeButtonLabelLocalizationCode?: string;
  removeAction?: () => Promise<void> | void;
  disabled: boolean;
  closeAction?: () => void;
  children?: React.ReactNode;
}> = observer(
  ({
    vm,
    descriptionLocalizationCode,
    removeButtonLabelLocalizationCode,
    closeButtonLabelLocalizationCode,
    removeAction,
    disabled,
    closeAction,
    children,
  }) => (
    <Alert variant="warning" className="p-4">
      <Row className="mt-0">
        <Col className="mt-0">
          <span className="text-dark font-weight-bold">
            {descriptionLocalizationCode ? vm.translate(descriptionLocalizationCode) : ""}
          </span>
        </Col>
      </Row>
      {children}
      {(removeAction || closeAction) && (
        <Row className="w-60 mt-4">
          <Col>
            {removeAction && removeButtonLabelLocalizationCode && (
              <Button
                disabled={disabled}
                variant="primary"
                size="sm"
                onClick={removeAction}
                className="mr-3 mb-3"
                style={{ textTransform: "none" }}>
                {vm.translate(removeButtonLabelLocalizationCode)}
              </Button>
            )}
            {closeAction && closeButtonLabelLocalizationCode && (
              <Button variant="light" size="sm" className="mb-3" onClick={closeAction} style={{ textTransform: "none" }}>
                {vm.translate(closeButtonLabelLocalizationCode)}
              </Button>
            )}
          </Col>
        </Row>
      )}
    </Alert>
  )
);

export default RecommendationAlert;
